import { camelToSnake, snakeToCamel } from "caseparser";

import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";

/* 
const ExercisesDisclaimerService = async function (token, first_alternative) {
  console.log(first_alternative);
  try {
    const requestOptions = {
      method: "POST",
      headers: headers(token),
      body: JSON.stringify({
        first_alternative,
      }),
    };
    console.log(requestOptions.body);
    return fetch(`${DOMAIN}api/v1/exercise-disclaimer`, requestOptions)
      .then(async (response) => {
        if (!response.ok) {
          return Promise.reject(response.status);
        }
        const data = await response.json();
        if (response.status === 200) {
          return {
            status: response.status,
            data: data.data,
          };
        }
      })
      .catch((error) => {
        return Promise.reject({
          status: error,
        });
      });
  } catch (e) {
    return Promise.reject({
      status: e,
    });
  }
};

*/

export const trainingWizardApi = api
  .enhanceEndpoints({ addTagTypes: [] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      finishTrainingWizard: builder.mutation({
        query: ({ userId, plan, position }) => ({
          url: `/training-wizard/finish`,
          method: RequestMethod.POST,
          body: camelToSnake({
            userId,
            plan,
            position,
          }),
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
      }),
    }),
  });

export const { useFinishTrainingWizardMutation } = trainingWizardApi;
